<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Api Keys</h4>
				</div>
				<div class="modal-body">
					<loading :active="loading">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<div class="row">
						<div class="col-md-12">
							<ul class="nav nav-tabs" role="tablist">
								<li role="presentation" class="active">
									<a href="#stripe" role="tab" data-toggle="tab" aria-expanded="true">
										<span class="visible-xs"><i aria-hidden="true" class="fa fa-cc-stripe"></i></span>
										<span class="hidden-xs">Stripe</span>
									</a>
								</li>
							</ul>
							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="stripe">
									<stripe v-if="statuses" :user="user" isAuth="isAuth" :statuses="statuses"></stripe>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	import Stripe from './Apis/Stripe'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
			'stripe': Stripe,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-api-keys'
				},
				loading: false,
				statuses: null,
			}
		},
		methods: {
			open() {
				this.getStatuses()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getStatuses() {
				this.loading = true
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
					this.loading = false
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/ApiKeys.vue